import { useState } from "react";
import {
  UsersCheckDuplicateMailAddressPostRequest,
  RequestCheckDuplicateEmailAddressRequest,
  UsersApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiCheckDuplicateMailAddress = () => {
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const checkDuplicateMailAddress = async (
    req: RequestCheckDuplicateEmailAddressRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: UsersCheckDuplicateMailAddressPostRequest = {
        req,
      };

      const api = new UsersApi(config);
      const response = await api.usersCheckDuplicateMailAddressPost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("メールアドレスチェックに失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { checkDuplicateMailAddress, result, error, isLoading };
};
